export const mapFileUrlToSameOrigin = (url: string) => {
  return url.replace(
    "https://poltrans-ejabberd-uploads.s3.eu-central-1.amazonaws.com",
    "https://app.slickshift.ai/files",
  )
}
